import { fetchUtils } from "react-admin";
import { tokenManager } from "./authProvider"; // 导入 tokenManager

// 全局变量，防止并发请求时多次更新 token
let isRefreshing = false;
let refreshSubscribers: ((token: string) => void)[] = [];

// 订阅 token 更新
const subscribeTokenRefresh = (callback: (token: string) => void) => {
    refreshSubscribers.push(callback);
};

// 发布 token 更新
const onTokenRefreshed = (token: string) => {
    refreshSubscribers.forEach(callback => callback(token));
    refreshSubscribers = [];
};

export const httpClient = async (url: string, options: fetchUtils.Options = {}) => {
    try {
        // 检查 token 是否需要更新
        if (tokenManager.shouldRenewToken() && !isRefreshing) {
            isRefreshing = true;

            try {
                const newToken = await tokenManager.renewToken();
                if (newToken) {
                    onTokenRefreshed(newToken);
                } else {
                    // Token 更新失败，抛出 401 错误
                    throw { status: 401, message: '登录已过期，请重新登录' };
                }
            } catch (error) {
                // Token 更新失败，清除认证数据
                tokenManager.clearAuthData();
                throw { status: 401, message: '登录已过期，请重新登录' };
            } finally {
                isRefreshing = false;
            }
        }

        // 如果正在更新 token，等待更新完成
        if (isRefreshing) {
            return new Promise((resolve, reject) => {
                subscribeTokenRefresh((token: string) => {
                    // 使用新 token 重新发起请求
                    executeRequest(url, options, token)
                        .then(resolve)
                        .catch(reject);
                });
            });
        }

        // 正常执行请求
        return executeRequest(url, options, localStorage.getItem("authToken"));
    } catch (error) {
        // 直接返回错误，不要重新抛出
        console.error('HTTP请求错误:', error);
        return {
            status: error.status || 500,
            headers: new Headers(),
            body: '',
            json: error.json || { message: error.message }
        };
    }
};

// 执行实际的请求
const executeRequest = async (url: string, options: fetchUtils.Options = {}, token: string | null) => {
    const headers = new Headers(options.headers || {});

    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }

    return fetchUtils.fetchJson(url, { ...options, headers })
        .then(response => {
            // 检查业务逻辑的 401 错误
            if (response.json?.code === 401 || response.json?.code === 2006) {
                throw { status: 401, message: '登录已过期，请重新登录' };
            }
            // if (response.json?.code == 2000) {
            //     throw { status: response.json?.code, message: '保存失败，该商城账号id已创建' };
            // }
            if (response.json?.code == 3123) {
                throw { status: response.json?.code, message: '可升级版本不能低于当前设备版本' };
            }
            if (response.json?.code == 3002 && response.json?.msg == '用户密码不匹配') {
                throw { status: response.json?.code, message: '旧密码错误' };
            }
            if (response.json?.code == 3002 && response.json?.msg == 'device is not existed') {
                throw { status: response.json?.code, message: '设备不存在' };
            }
            if (response.json?.code != 0) {
                throw { status: response.json?.code, message: response.json?.msg };
            }
            return response;
        })
        .catch(error => {
            console.log(error, 'data.catch')
            // 处理 HTTP 401 或业务逻辑的 401
            if (error.status === 401 || error.json?.code === 401) {
                // 清除认证数据
                tokenManager.clearAuthData();
                throw { status: 401, message: '登录已过期，请重新登录' };
            }
            throw error;
        });
};